<div class="ai-bubble" [class.is-trial]="isTrialLocked" (click)="$event.stopPropagation()">

  <!-- Configure bubble content -->
  <div *ngIf="isConfigure" class="configure-content">
    <p class="m-0 p-0">
      {{ 'AI_ASSISTANT.CONFIGURE_API_KEY_NOTICE' | translate }}
    </p>
    <div class="d-flex justify-content-center mt-1">
      <button class="dialog-action-btn dialog-action-btn-primary" (click)="onOpenSettings()">
        {{ 'AI_ASSISTANT.OPEN_SETTINGS' | translate }}
      </button>
    </div>
  </div>

  <!-- Generate bubble content -->
  <div *ngIf="isGenerate" class="generate-content" [formGroup]="form">

    <!-- Description section -->
    <app-select-input
      formControlName="description"
      [label]="'CREATE_EDIT_SMAP.FIELDS.DESCRIPTION' | translate"
      [options]="descriptionOptions"
      [isIcon]="false"
      [noMargin]="true"
      [labelColSize]="4"
      [dropdownIconColSize]="8"
      tooltipPosition="left">
    </app-select-input>

    <!-- Properties section -->
    <app-select-input
      formControlName="properties"
      [label]="'MAP_INFO.PROPERTIES' | translate"
      [options]="propertiesOptions"
      [isIcon]="false"
      [labelColSize]="4"
      [dropdownIconColSize]="8"
      tooltipPosition="left">
    </app-select-input>
    <!-- Actions section -->
    <div class="d-flex justify-content-center mt-1">
      <button class="dialog-action-btn dialog-action-btn-primary generate-btn"
        [disabled]="isGenerateDisabled || isSubmitting"
        (click)="onGenerate()">
        {{ isSubmitting ? ('AI_ASSISTANT.GENERATING' | translate) : ('AI_ASSISTANT.GENERATE' | translate) }}
      </button>
    </div>
    <app-slide-toggle-input [label]="'AI_ASSISTANT.DISPLAY_ON_LONG_PRESS' | translate" formControlName="longPressOnly"></app-slide-toggle-input>

  </div>

  <!-- Image generation warning content -->
  <div *ngIf="isImageWarning" class="image-warning-content">
    <ng-container *ngIf="isTrialLocked; else regularImageWarning">
      <maporium-end-trial-frame
        [text]="'AI_ASSISTANT.IMAGE_TRIAL_MESSAGE' | translate"
        [requireCardOnFile]="false"
        (trialEnded)="onImageTrialEnded()">
      </maporium-end-trial-frame>
    </ng-container>

    <ng-template #regularImageWarning>
      <p class="m-0 warning-text">
        {{ imageWarningText }}
      </p>
      <div class="d-flex justify-content-center mt-1">
        <button class="dialog-action-btn dialog-action-btn-primary generate-btn"
                [disabled]="isSubmitting"
                (click)="onImageWarningGenerate()">
          {{ isSubmitting ? ('AI_ASSISTANT.GENERATING' | translate) : ('AI_ASSISTANT.GENERATE' | translate) }}
        </button>
      </div>
      <mat-checkbox class="do-not-show-again"
                    [checked]="doNotShowAgain"
                    [disabled]="isSubmitting"
                    (change)="onDoNotShowAgainChange($event.checked)">
        {{ 'AI_ASSISTANT.IMAGE_WARNING_DO_NOT_SHOW_AGAIN' | translate }}
      </mat-checkbox>
    </ng-template>
  </div>

  <!-- Arrow pointing up -->
  <div class="bubble-arrow"></div>
</div>
